export default __webpack_public_path__ + "static/media/liex-03.38ff015e.png";